/**
 * Copyright (c) 2026-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Remix Icon License v1.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const HeartLine = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M16.5 3C19.54 3 22 5.5 22 9c0 7-7.5 11-10 12.5C9.5 20 2 16 2 9c0-3.5 2.5-6 5.5-6C9.36 3 11 4 12 5c1-1 2.64-2 4.5-2m-3.57 15.6a27 27 0 0 0 2.42-1.7C18.34 14.53 20 11.94 20 9c0-2.36-1.54-4-3.5-4a4.6 4.6 0 0 0-3.09 1.41L12 7.83 10.59 6.4A4.6 4.6 0 0 0 7.5 5C5.56 5 4 6.66 4 9c0 2.94 1.67 5.53 4.64 7.9A27 27 0 0 0 12 19.17z" />
  </Icon>
);
